import { InjectionToken } from '@angular/core';

/**
 * Per-app settings for the shared add-in platform layer. Each add-in provides
 * these once in its app config; the shared services and components read them
 * instead of hard-coding host specific values.
 */
export interface AddInCoreConfig {
  /**
   * Route the user lands on after a successful login, e.g. '/apps' in the word
   * add-in and '/' in the mail add-in.
   */
  homeRoute: string;
}

export const DEFAULT_ADDIN_CORE_CONFIG: AddInCoreConfig = {
  homeRoute: '/'
};

/**
 * Falls back to {@link DEFAULT_ADDIN_CORE_CONFIG} so shared code stays usable
 * without every consumer (tests included) having to wire the token up.
 */
export const ADDIN_CORE_CONFIG = new InjectionToken<AddInCoreConfig>('ADDIN_CORE_CONFIG', {
  providedIn: 'root',
  factory: (): AddInCoreConfig => DEFAULT_ADDIN_CORE_CONFIG
});
